var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1135 2.40681L11.0278 2.52781L11.0058 2.49677C8.88743 -0.537997 3.99466 -1.16562 1.36975 2.64136C-2.33178 8.01121 1.71113 16.3891 10.5756 20.8731C10.8594 21.0167 11.1946 21.0167 11.4784 20.8731C20.3426 16.3891 24.3853 8.01115 20.6839 2.64146C18.0928 -1.11689 13.2673 -0.562065 11.1135 2.40681ZM19.1623 3.96608C21.74 8.04883 18.573 14.726 11.2721 18.7219L11.0268 18.8528L10.7818 18.7219C3.36659 14.6636 0.215663 7.83956 3.01637 3.77655C5.24698 0.541432 9.86717 2.09653 10.0231 5.63829L10.0275 5.84589L10.0373 5.97746C10.1853 7.11853 11.8982 7.09913 12.0203 5.955L12.0268 5.79981L12.0307 5.65488C12.1714 2.08278 16.8084 0.543696 19.0373 3.77662L19.1623 3.96608Z",
    fill: "#78264F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.408105d0.svg";
export { ForwardRef as ReactComponent };